import { useI18n } from '../i18n';
import { useAppUpdate } from '../hooks/useAppUpdate';
import { UpdateSheet } from '../components/AppUpdate';

/**
 * W23 "please update": an unsupported build sees a blocking update sheet; a newer optional build
 * is offered once (with "Later"). Signed in or not — the check is public. Nothing shows when the
 * check is off or fails.
 */
export function UpdateGate() {
  const { t } = useI18n();
  const update = useAppUpdate();
  if (update.mode === 'none') return null;
  const required = update.mode === 'required';
  const reload = update.actionKind === 'reload';
  return (
    <UpdateSheet
      required={required}
      reload={reload}
      notes={update.notes}
      onUpdate={update.update}
      onLater={update.later}
      labels={{
        title: t(required ? 'update.requiredTitle' : 'update.availableTitle'),
        body: t(required ? 'update.requiredBody' : 'update.availableBody'),
        version: update.latestVersion
          ? t('update.version', { version: update.latestVersion })
          : null,
        notesTitle: t('update.notes'),
        action: t(reload ? 'update.reload' : required ? 'update.now' : 'update.update'),
        later: t('update.later'),
      }}
    />
  );
}
